import type { ReactNode } from 'react';

export const symbol_travel: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M448-548 178-663q-19.89-9.35-24.44-30.17Q149-714 164.74-730.29L178-744q8-8 17.53-10.5 9.53-2.5 19.47-.5l374 65 133-133q21-21 50.5-21t50.5 21q21 21 21 50.5T823-722L690-589l65 374q2 9.67-.5 19.33Q752-186 744-178l-13.71 12.79Q714-149 693-153.5T663-178L548-448 427-326l23 131q2 8.36-.67 16.3-2.66 7.94-8.5 13.79l-14.16 14.21Q415-139 398.12-141.5 381.24-144 373-159l-74-140-140-74q-15-8.24-17.5-25.12-2.5-16.88 9.2-28.55l14.21-14.16q5.85-5.84 13.79-8.5 7.94-2.67 16.3-.67l131 23 122-121Z"
		/>
	</svg>
);
